import { createContext, useContext, type ReactNode } from 'react';
import { useCapabilities, type UseCapabilities } from './useCapabilities';

/**
 * Shares ONE capabilities fetch + the active-vendor selection across the whole
 * app, so the shell's vendor switcher and every screen agree on which vendor is
 * active (a per-route `useCapabilities()` would each hold its own state).
 */
const CapabilitiesContext = createContext<UseCapabilities | null>(null);

export function CapabilitiesProvider({ children }: { children: ReactNode }) {
  const value = useCapabilities();
  return <CapabilitiesContext.Provider value={value}>{children}</CapabilitiesContext.Provider>;
}

export function useVendor(): UseCapabilities {
  const ctx = useContext(CapabilitiesContext);
  if (!ctx) throw new Error('useVendor must be used within a CapabilitiesProvider');
  return ctx;
}
